"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Duplicate;

var _Duplicate = require("@adobe/react-spectrum-workflow/dist/Duplicate.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Duplicate(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Duplicate.A4uDuplicate, null));
}